import { failToast } from '@utils/toast';
import Horn from '@utils/horn';
import { getStorage } from '@utils/localStorage';
import { reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';
import { isUniversalWindowsXP, isInOldApp4 } from '@utils/getEnv';

import * as API from '../../api';
import { RootDispatch } from '..';
import { IQueryMenuItem, IMenuInfo, MatchedMenuType } from '../../api/define';

export interface IState {
    // 左侧菜单是否折叠
    isMenuFolded: boolean;
    /** hover时展开菜单 */
    hoverMenuUnFold: boolean;
    leftMenuList: IQueryMenuItem[];
    /** 前端自定义的菜单匹配信息 */
    menuInfo: IMenuInfo;
    /** 菜单权限控制 */
    menuAuth: string;
    /** 高亮菜单 */
    matchedMenu: MatchedMenuType;
    /** 商品tag数 */
    lowQualitySpusCount: number;
}

const shellLeftMenu = {
    name: 'shellLeftMenu',
    state: {
        isMenuFolded: false,
        hoverMenuUnFold: false,
        leftMenuList: [],
        menuInfo: {},
        menuAuth: '',
        matchedMenu: {
            menuCode: '',
            menuName: '',
            subMenuCode: '',
            subMenuName: '',
        },
        lowQualitySpusCount: 0,
    } as IState,
    reducers: {
        setData(state: IState, payload: Partial<IState>) {
            return {
                ...state,
                ...payload,
            };
        },
        setMenuFold(state: IState, payload: boolean) {
            state.isMenuFolded = payload;
            return {
                ...state,
            };
        },
        setHoverMenuUnFold(state: IState, payload: boolean) {
            state.hoverMenuUnFold = payload;
            return {
                ...state,
            };
        },
        setMatchedMenu(state: IState, payload: MatchedMenuType) {
            state.matchedMenu = { ...payload };
            return {
                ...state,
            };
        },
        setLowQualitySpusCount(state: IState, payload: number) {
            state.lowQualitySpusCount = payload;
            return {
                ...state,
            };
        },
    },
    effects: (dispatch: RootDispatch) => ({
        /** 获取左侧菜单列表 */
        async getLeftMenuList() {
            try {
                const res = await API.getQueryMenu();
                if (res.code === 0) {
                    const { data } = res;
                    /**
                     * TODO: 后续需要根据poiInfo来判断是否为美食集合店
                     * 1、星巴克门店返回：["searchBox","printIcon","businessState","wmPoiIdAll", "IM", "pushMessage"]
                     * 2、集合点门店返回：["printIcon",  "printConfig",  "autoAcceptConfig"]
                     * 3、其他门店返回空list：[]
                     */
                    let customizedShowArr: string[] | undefined;
                    if (getStorage('customizedShow')) {
                        customizedShowArr = getStorage('customizedShow')?.split(',');
                    }
                    data.menus.forEach(menu => {
                        if (Array.isArray(menu.subMenus)) {
                            menu.subMenus.forEach(subMenu => {
                                if (
                                    subMenu.menuCode === 'Sub.ShopManage' &&
                                    customizedShowArr &&
                                    !(
                                        customizedShowArr?.length === 3 &&
                                        customizedShowArr.every(item =>
                                            [
                                                'printIcon',
                                                'printConfig',
                                                'autoAcceptConfig',
                                            ].includes(item),
                                        )
                                    )
                                ) {
                                    subMenu.url = '/new_fe/business#/shop/manage/newShopPrivilege';
                                }
                                // 餐饮新形态在xp和老壳子，强制非灰度处理
                                if (isUniversalWindowsXP || isInOldApp4) {
                                    /** 今日待办 重置为待处理 */
                                    if (subMenu.menuCode === 'Sub.WMOrderUnprocessedNewModel') {
                                        subMenu.menuCode = 'Sub.WMOrderUnprocessedNew';
                                        subMenu.url = '/new_fe/business#/order/unprocessed';
                                        subMenu.mask = '';
                                        subMenu.subMenuName = '待处理';
                                        subMenu.rank = '13';
                                    }
                                    /** 全部订单 重置为历史订单 */
                                    if (subMenu.menuCode === 'Sub.WMOrderHistoryNewModel') {
                                        subMenu.menuCode = 'Sub.WMOrderHistoryNew';
                                        subMenu.url = '/new_fe/business#/order/history';
                                        subMenu.mask = '';
                                        subMenu.subMenuName = '历史订单';
                                        subMenu.rank = '14';
                                    }
                                }
                            });
                        }
                    });
                    dispatch.shellLeftMenu.setData({ leftMenuList: data.menus });
                } else {
                    failToast('获取菜单列表失败');
                }
                reportCustomMetrics(CUSTOM_METRICS.QUERYMENU_API.KEY, 1, {
                    [CUSTOM_METRICS.QUERYMENU_API.TAGS.HTTP_SUCCESS]: 1,
                    [CUSTOM_METRICS.QUERYMENU_API.TAGS.BUSINESS_CODE]: res.code,
                });
            } catch (e) {
                failToast('获取菜单列表失败');
                reportCustomMetrics(CUSTOM_METRICS.QUERYMENU_API.KEY, 1, {
                    [CUSTOM_METRICS.QUERYMENU_API.TAGS.HTTP_SUCCESS]: 0,
                });
            }
        },
        /** 获取前端自定义的菜单匹配信息 */
        async getLeftMenuInfo() {
            try {
                let response = Horn.getConfigByFieldName<IMenuInfo>(
                    Horn.CONFIG_FIELD.MENU_MATCH_CONFIG,
                );

                if (response === null) {
                    response = {};
                }
                // if (response.switch === true) {
                //     //开关打开，存储前端自定义配置
                //     setStorage('waimai_e_menu_match_info', JSON.stringify(response.data || {}));
                // } else {
                //     //反之，清除配置，便于降级
                //     removeStorage('waimai_e_menu_match_info');
                // }
                dispatch.shellLeftMenu.setData({ menuInfo: response });
            } catch (e) {
                failToast('网络异常，请稍后再试');
            }
        },
        /** 菜单权限 */
        async getMenuAuth() {
            try {
                const response = await API.getMenuAuth();
                dispatch.shellLeftMenu.setData({ menuAuth: response });
            } catch (e) {
                failToast('网络异常，请稍后再试');
            }
        },
        /** 获取 menu-商品待处理tag数 */
        async getLowQualitySpusCount() {
            try {
                const response = await API.getLowQualitySpusCount();
                dispatch.shellLeftMenu.setData({ lowQualitySpusCount: response });
            } catch (e) {
                failToast('网络异常，请稍后再试');
            }
        },
    }),
};

export default shellLeftMenu;
